import { createSlice } from "@reduxjs/toolkit"

  export const registerSlice = createSlice({
    name: 'register',
    initialState:{
      registerData:'',
      registerDataMail:'',
      registerDataCode:'',
      registerTimer:0
    },
    reducers: {
      setRegister:(state, action) => {
        state.registerData = action.payload
      },
      setRegisterMail:(state, action) => {
        state.registerDataMail = action.payload
      },
      setRegisterCode:(state, action) => {
        state.registerDataCode = action.payload
      },
      setTimer:(state, action) => {
        state.registerTimer = action.payload
      },
    },
  })
  
  export const { setRegister, setRegisterMail,setRegisterCode,setTimer  } = registerSlice.actions
  
  export default registerSlice.reducer